const filters = [
    {
        id: '1',
        slug: 'filtri',
        name: 'ფილტრი',
        categories: [
            {
                id: '101',
                slug: 'seqtori',
                name: 'კატეგორია',
                types: [
                    {id: '1001', slug: 'dasaqmeba', name: 'დასაქმება'},
                    {id: '1002', slug: 'onlain-tamashebi', name: 'სასწავლო თამაშები'},
                    {id: '1003', slug: 'inglisuris-kursebi', name: 'ინგლისურის კურსები'},
                    {id: '1004', slug: 'saswavleblebi', name: 'სასწავლებლები'},
                    {id: '1005', slug: 'kursebi', name: 'სხვა კურსები'},
                    // {id: '1006', slug: 'vakansiebi-jobs', name: 'ვაკანსიები'},
                    // {id: '1007', slug: 'teqnika', name: 'ტექნიკა'},
                    // {id: '1008', slug: 'avtonawilebi', name: 'ავტონაწილები'},
                    // {id: '1009', slug: 'dasuftaveba', name: 'დასუფთავება'},
                    // {id: '1010', slug: 'gazgasamarti', name: 'გაზგასამართი'},
                    // {id: '1011', slug: 'sastumroebi', name: 'სასტუმროები'},
                    // {id: '1012', slug: 'dizaini', name: 'დიზაინი'},
                    // {id: '1013', slug: 'masalebi', name: 'მასალები'},
                    // {id: '1014', slug: 'maraziebi', name: 'მაღაზიები'},
                    // {id: '1015', slug: 'finansebi', name: 'ფინანსები'},
                    // {id: '1016', slug: 'makulatura', name: 'მაკულატურა'},
                    // {id: '1017', slug: 'kvleva', name: 'კვლევა'},
                    // {id: '1018', slug: 'vawroba', name: 'ვაჭრობა'},
                    // {id: '1019', slug: 'momsaxureba', name: 'მომსახურება'},
                    // {id: '1020', slug: 'bewdva', name: 'ბეჭდვა'},
                    // {id: '1021', slug: 'samseneblo', name: 'სამშენებლო'},
                    // {id: '1022', slug: 'rkinigza', name: 'რკინიგზა'},
                    // {id: '1023', slug: 'organizaciebi', name: 'ორგანიზაციები'},
                    // {id: '1024', slug: 'mcenareebi', name: 'მცენარეები'},
                    // {id: '1025', slug: 'proeqtireba', name: 'პროექტირება'},
                    // {id: '1026', slug: 'gatboba', name: 'გათბობა'},
                    // {id: '1027', slug: 'samedicino', name: 'სამედიცინო'},
                    // {id: '1028', slug: 'treiningi', name: 'ტრეინინგი'},
                    // {id: '1029', slug: 'avtoservisi', name: 'ავტოსერვისი'},
                    // {id: '1030', slug: 'sakonsultacio', name: 'საკონსულტაციო'},
                    // {id: '1031', slug: 'interneti', name: 'ინტერნეტი'},
                    // {id: '1032', slug: 'parkebi', name: 'პარკები'},
                    // {id: '1033', slug: 'bibliotekebi', name: 'ბიბლიოთეკები'},
                    // {id: '1034', slug: 'gartoba', name: 'გართობა'},
                    // {id: '1035', slug: 'advokatebi', name: 'ადვოკატები'},
                    // {id: '1036', slug: 'arbitrajebi', name: 'არბიტრაჟები'},
                    // {id: '1037', slug: 'kursebi', name: 'კურსები'},
                    // {id: '1038', slug: 'avia', name: 'ავია'},
                    // {id: '1039', slug: 'asociaciebi', name: 'ასოციაციები'},
                    // {id: '1040', slug: 'taqsi', name: 'ტაქსი'},
                    // {id: '1041', slug: 'biznesi', name: 'ბიზნესი'},
                    // {id: '1042', slug: 'avtosadgurebi', name: 'ავტოსადგურები'},
                    // {id: '1043', slug: 'rkinigzis-sadgurebi', name: 'რკინიგზის სადგურები'},
                    // {id: '1044', slug: 'turebi', name: 'ტურები'},
                    // {id: '1045', slug: 'tansacmeli', name: 'ტანსაცმელი'},
                    // {id: '1046', slug: 'sporti', name: 'სპორტი'},
                    // {id: '1047', slug: 'salonebi', name: 'სალონები'},
                    // {id: '1048', slug: 'tavsesafrebi', name: 'თავშესაფრები'},
                    // {id: '1049', slug: 'klinikebi', name: 'კლინიკები'},
                    // {id: '1050', slug: 'meurneobebi', name: 'მეურნეობები'},
                    // {id: '1051', slug: 'bazrebi', name: 'ბაზრები'},
                    // {id: '1052', slug: 'dasveneba', name: 'დასვენება'},
                    // {id: '1053', slug: 'bavsvta', name: 'ბავშთა'},
                    // {id: '1054', slug: 'fitnesi', name: 'ფიტნესი'},
                    // {id: '1055', slug: 'sasamartloebi', name: 'სასამართლოები'},
                    // {id: '1056', slug: 'usafrtxoeba', name: 'უსაფრთხოება'},
                    // {id: '1057', slug: 'arqivebi', name: 'არქივები'},
                    // {id: '1058', slug: 'santeqnika', name: 'სანტექნიკა'},
                    // {id: '1059', slug: 'studiebi', name: 'სტუდიები'},
                    // {id: '1060', slug: 'sareabilitacio', name: 'სარეაბილიტაციო'},
                    // {id: '1061', slug: 'fondebi', name: 'ფონდები'},
                    // {id: '1062', slug: 'foto', name: 'ფოტო'},
                    // {id: '1063', slug: 'uzravi-qoneba', name: 'უძრავი-ქონება'},
                    // {id: '1064', slug: 'wyali', name: 'წყალი'},
                    // {id: '1065', slug: 'jarti', name: 'ჯართი'},
                    // {id: '1066', slug: 'farmacevtuli', name: 'ფარმაცევტული'},
                    // {id: '1067', slug: 'ansamblebi', name: 'ანსამბლები'},
                    // {id: '1068', slug: 'aftiaqebi', name: 'აფთიაქები'},
                    // {id: '1069', slug: 'gaqiraveba', name: 'გაქირავება'},
                    // {id: '1070', slug: 'darbazebi', name: 'დარბაზები'},
                    // {id: '1071', slug: 'kompiuteruli', name: 'კომპიუტერული'},
                    // {id: '1072', slug: 'transportireba', name: 'ტრანსპორტირება'},
                    // {id: '1073', slug: 'reklama', name: 'რეკლამა'},
                    // {id: '1074', slug: 'dasuftaveba', name: 'დასუფთავება'},
                    // {id: '1075', slug: 'reklama', name: 'რეკლამა'},
                    // {id: '1076', slug: 'ganateba', name: 'განათება'},
                    // {id: '1042', slug: 'sxvadasxva', name: 'სხვადასხვა'},

                ]
            },
            // {
            //     id: '102',
            //     slug: 'qalaqi',
            //     name: 'ქალაქი',
            //     types: [
            //         {id: '1004', slug: 'vake', name: 'ვაკე-საბურთალო'},
            //         {id: '1005', slug: 'chugureti', name: 'ჩუღურეთი'},
            //         {id: '1006', slug: 'isani-samgori', name: 'ისანი-სამგორი'},
            //         {id: '1007', slug: 'saburtalo', name: 'საბურთალო'},
            //         {id: '1009', slug: 'didi-dighomi', name: 'დიდი დიღომი'},
            //         {id: '1010', slug: 'mtawminda', name: 'მთაწმინდა'},
            //         {id: '1011', slug: 'krwanisi', name: 'კრწანისი'},
            //         {id: '1012', slug: 'gldani', name: 'გლდანი'},
            //         {id: '1013', slug: 'batumi', name: 'ბათუმი'},
            //         {id: '1014', slug: 'qobuleti', name: 'ქობულეთი'},
            //         {id: '1015', slug: 'axalcixe', name: 'ახალციხე'},
            //         {id: '1016', slug: 'kutaisi', name: 'ქუთაისი'},
            //         {id: '1017', slug: 'rustavi', name: 'რუსთავი'},
            //         {id: '1018', slug: 'telavi', name: 'თელავი'},
            //         {id: '1019', slug: 'zugdidi', name: 'ზუგდიდი'},
            //         {id: '1020', slug: 'gori', name: 'გორი'},
            //         {id: '1021', slug: 'mcxeta', name: 'მცხეთა'},
            //         {id: '1022', slug: 'foti', name: 'ფოთი'},
            //         {id: '1023', slug: 'lagodexi', name: 'ლაგოდეხი'},
            //         {id: '1024', slug: 'gardabani', name: 'გარდაბანი'},
            //         {id: '1025', slug: 'duseti', name: 'დუშეთი'},
            //         {id: '1026', slug: 'senaki', name: 'სენაკი'},
            //         {id: '1027', slug: 'marneuli', name: 'მარნეული'},
            //     ]
            // },
        ]
    },
];

export default filters;